export const WS_BASE = `wss://${process.env.REACT_APP_API_URL}/`;
const ws = new WebSocket(WS_BASE);
ws.onclose = (e) => {
  console.log("WebSocket connection closed", e);
};

export default ws;
